export default "<div *ngIf=\"loaderService.getLoadingState()\">\n  <div class=\"loadesr\"></div>\n</div>";